import CoreuiController from "../lib/coreui-controller"
import Dropdown from "../coreui/dropdown"

export default class CoreuiDropdownController extends CoreuiController {
  static Component = Dropdown
}
